import { FC } from 'react';
import cx from 'classnames/bind';

import CursorIcon from '@/assets/cursor.svg';

import styles from './Cursor.module.scss';

interface CursorProps {
  className?: string;
  direction?: 'right' | 'left';
}

const cn = cx.bind(styles);

const Cursor: FC<CursorProps> = ({ className, direction = 'left' }) => (
  <img
    src={CursorIcon}
    className={cn('cursor', className, `cursor-${direction}`)}
    alt="Иконка курсора"
  />
);

export default Cursor;
